export const COMPENSATION_BASIS = 'art 10 ust.1 Ustawy o przeciwdziałaniu nadmiernym opóźnieniom w transakcjach handlowych';
export const COMPENSATION_BASIS_ACT = 'Ustawy o przeciwdziałaniu nadmiernym opóźnieniom w transakcjach handlowych';
export const COMPENSATION_BASIS_SHORT = 'NadmOpTransHandlU';